export class TwoFactorDuoDeleteRequest {
  constructor(public userVerificationToken: string) {}
}
